import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialGroupItemCategoriesByTrialGroupId: ITrialGroupItemCategoriesLoadByTrialGroupIdActionCreator = (trialGroupId) => {
        return {
            type: ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID,
            trialGroupId
        }
    },
    LoadSuccess: ITrialGroupItemCategoriesLoadByTrialGroupIdSuccessActionCreator = (formData, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID_SUCCESS,
            formData,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialGroupItemCategoriesLoadByTrialGroupIdFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialGroupItemCategoriesClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALGROUPITEMCATEGORIES_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialGroupItemCategoriesFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALGROUPITEMCATEGORIES_FILTER,
            formFilter
        }
    };


export const
    ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID = "ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID",
    ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID_SUCCESS = "ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID_SUCCESS",
    ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID_FAILURE = "ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID_FAILURE",

    ACTION_TRIALGROUPITEMCATEGORIES_CLEAR = "ACTION_TRIALGROUPITEMCATEGORIES_CLEAR",

    ACTION_TRIALGROUPITEMCATEGORIES_FILTER = "ACTION_TRIALGROUPITEMCATEGORIES_FILTER";

export interface ITrialGroupItemCategoriesLoadByTrialGroupIdAction {
    type: "ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID";
    trialGroupId?: number;
}

export interface ITrialGroupItemCategoriesLoadByTrialGroupIdActionCreator {
    (trialGroupId?: number): ITrialGroupItemCategoriesLoadByTrialGroupIdAction;
}

export interface ITrialGroupItemCategoriesLoadByTrialGroupIdSuccessAction {
    type: "ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID_SUCCESS";
    formData: Dtos.TrialGroupItemCategory[];
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupItemCategoriesLoadByTrialGroupIdSuccessActionCreator {
    (
        formData: Dtos.TrialGroupItemCategory[],
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupItemCategoriesLoadByTrialGroupIdSuccessAction;
}

export interface ITrialGroupItemCategoriesLoadByTrialGroupIdFailureAction {
    type: "ACTION_TRIALGROUPITEMCATEGORIES_LOAD_BY_TRIALGROUPID_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupItemCategoriesLoadByTrialGroupIdFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupItemCategoriesLoadByTrialGroupIdFailureAction;
}

export interface ITrialGroupItemCategoriesClearAction {
    type: "ACTION_TRIALGROUPITEMCATEGORIES_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialGroupItemCategoriesClearActionCreator {
    (propertiesToClear?: string[]): ITrialGroupItemCategoriesClearAction;
}

export interface ITrialGroupItemCategoriesFilterActionCreator {
    (formFilter: IFormFilter): ITrialGroupItemCategoriesFilterAction;
}

export interface ITrialGroupItemCategoriesFilterAction {
    type: "ACTION_TRIALGROUPITEMCATEGORIES_FILTER";
    formFilter: IFormFilter;
}

export type TrialGroupItemCategoryActions =
    ITrialGroupItemCategoriesLoadByTrialGroupIdAction |
    ITrialGroupItemCategoriesLoadByTrialGroupIdSuccessAction |
    ITrialGroupItemCategoriesLoadByTrialGroupIdFailureAction |
    ITrialGroupItemCategoriesClearAction |
    ITrialGroupItemCategoriesFilterAction;